import React from "react";
import ProjectWorkflowContainer from "../containers/project/ProjectWorkflowContainer/ProjectWorkflowContainer";
import BlankLayout from "../layouts/BlankLayout";
import { StyleSheet } from "react-native";

function ProjectView() {
  return (
    <BlankLayout flexDirection="column">
      <ProjectWorkflowContainer />
    </BlankLayout>
  );
}

export default ProjectView;
